/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SalesInputs */

const en_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sales`)
};

const es_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ventas`)
};

const fr_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ventes`)
};

const de_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufe`)
};

const ja_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売上`)
};

const zh_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销量`)
};

const ar_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مبيعات`)
};

const id_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`penjualan`)
};

const it_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vendite`)
};

const ru_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продаж`)
};

const pt_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vendas`)
};

const ko_sales = /** @type {(inputs: SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매`)
};

/**
* | output |
* | --- |
* | "sales" |
*
* @param {SalesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sales = /** @type {((inputs?: SalesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SalesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sales(inputs)
	if (locale === "es") return es_sales(inputs)
	if (locale === "fr") return fr_sales(inputs)
	if (locale === "de") return de_sales(inputs)
	if (locale === "ja") return ja_sales(inputs)
	if (locale === "zh") return zh_sales(inputs)
	if (locale === "ar") return ar_sales(inputs)
	if (locale === "id") return id_sales(inputs)
	if (locale === "it") return it_sales(inputs)
	if (locale === "ru") return ru_sales(inputs)
	if (locale === "pt") return pt_sales(inputs)
	return ko_sales(inputs)
});